export const getContainedSVGCoordinates = (
  e: MouseEvent,
  element: SVGSVGElement | SVGImageElement | null,
  viewBox: string
): { x: number; y: number } => {
  if (!element) return { x: 0, y: 0 };

  const rect = element.getBoundingClientRect();
  const viewBoxParts = viewBox.split(' ').map(Number);
  const [vbX, vbY, vbWidth, vbHeight] = viewBoxParts;

  const scaleX = vbWidth / rect.width;
  const scaleY = vbHeight / rect.height;

  let x = Math.round(vbX + (e.clientX - rect.left) * scaleX);
  let y = Math.round(vbY + (e.clientY - rect.top) * scaleY);

  x = Math.max(0, Math.min(x, vbWidth));
  y = Math.max(0, Math.min(y, vbHeight));

  return { x, y };
};
